import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ComponentFactoryResolver, ViewContainerRef } from '@angular/core';

import { Message } from '../publisher/message';
import { PublisherService } from '../publisher/publisher.service';
import { UserService } from '../user/user.service';
import { HeaderService } from './header.service';
import { SettingsEntry } from './setting-entries/settings-entry';

@Component({
    selector: 'header-menu',
    templateUrl: './header-menu.component.html',
    styleUrls: ['./header-menu.component.scss']
})
export class HeaderMenuComponent implements OnInit, OnDestroy {

    showSettingsPopup: boolean = false;
    settingEntries: SettingsEntry[];
    headerService: HeaderService;
    userService: UserService;

    constructor(
        private pubService: PublisherService,
        private viewContainerRef: ViewContainerRef,
        private componentFactoryResolver: ComponentFactoryResolver,
        headerService: HeaderService,
        userService: UserService,
        private cdr: ChangeDetectorRef,
        @Inject('SettingsEntry') settingEntries: SettingsEntry[],
    ) {
        this.headerService = headerService;
        this.userService = userService;
        this.settingEntries = settingEntries;
        this.headerService.mode = 'items';
    }

    ngOnInit() {
        this.headerService.updateHeaderComponent(this);
        this.pubService.subscribeToChannel('clicked-outside').subscribe(
            (msg: Message) => {
                if (msg.Owner !== this) {
                    this.showSettingsPopup = false;
                }
            }
        )
    }

    refreshChanges() {
        this.cdr.detectChanges();
    }

    popupClicked(evt: MouseEvent, itemName: string) {
        this.headerService.popupClicked(itemName);
        evt.stopPropagation();
    }

    itemClicked(evt: MouseEvent) {
        this.headerService.itemClicked();
        evt.stopPropagation();
    }

    onSettingsClicked(evt: MouseEvent) {
        this.showSettingsPopup = !this.showSettingsPopup;
        this.pubService.sendToChannel('clicked-outside', new Message('', this));
        evt.stopPropagation();
    }

    onEntryClicked(evt: MouseEvent, entry: SettingsEntry) {
        this.showSettingsPopup = false;
        entry.activate(this.viewContainerRef);
        evt.stopPropagation();
    }

    ngOnDestroy() {
        for (let entry of this.settingEntries) {
            entry.clean();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/headerfooter/header-menu.component.ts